<template>
  <div class="row">
    <div class="col-md-4" v-for="novedades in listNovedades" :key="novedades.id">
      <router-link
        :to="{ name: 'detalleNovedades', params: { id: novedades.id } }"
      >
        <div class="card" :class="{ novedad: !novedades.visto }">
          <img :src="novedades.foto" class="image" />
          <div style="padding: 14px">
            <div class="row">
              <div class="col-md-12" style="text-align: right">
                <time
                  class="time"
                  style="font-style: italic; font-weight: bold; font-size: 13px"
                >
                  {{ novedades.date | parseDateNovedades }}
                </time>
              </div>
              <div class="col-md-12">
                <span class="titulo">{{ novedades.title | capitalize }}</span>
              </div>
            </div>
            <div class="bottom clearfix">
              <p class="resume-text">
                {{ cleanSummary(novedades.resume) }}<strong>...</strong>
                <router-link
                  :to="{ name: 'detalleNovedades', params: { id: novedades.id } }"
                  class="read-more-link"
                >
                  leer más
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>


<script>
import { Card, Row, Button, Col } from "element-ui";

export default {
  name: "news",
  components: {
    [Card.name]: Card,
    [Row.name]: Row,
    [Button.name]: Button,
    [Col.name]: Col,
  },
  created() {
    this.$store.dispatch("setNameRoute", "Novedades");
    this.getNovedades();
  },
  data() {
    return {
      // currentDate: new Date(),
      listNovedades: "",
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    cleanSummary(text) {
      let cleanedText = text.trim();

      if (cleanedText.endsWith('.')) {
        cleanedText = cleanedText.slice(0, -1);
      }

      return cleanedText;
    },
    getNovedades() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "novedades/getNovedadesByUser",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listNovedades = response.data.result.listNovedades;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>

/* .card {
  min-height: 440px;
} */

.titulo {
  font-weight: bold;
  color: #1E22AA;
  font-size: 22px;
  line-height: 30px;
  text-align: justify;
}

.time {
  font-size: 16px;
  color: #777;
  line-height: 16px;
}

.bottom {
  margin-top: 14px;
}

.resume-text {
  line-height: 1.4;
  font-size: 14px;
  color: #555;
  text-align: justify;
}

.read-more-link {
  color: #1E22AA;
  font-weight: bold;
  /* text-decoration: underline; */
}

.read-more-link:hover {
  color: #00384f;
}

.button:hover {
  background-color: #00384f;
  border-color: #00384f;
  margin-top: 13px;
  line-height: 10px;
}

.image {
  width: 100%;
  display: block;
  padding: 14px;
}

.novedad {
  /* Sombra superior sin desenfoque */
  -webkit-box-shadow: 0px 0px 16px 3px #1E22AA;
  -moz-box-shadow: 0px 0px 15px 3px #1E22AA;
  box-shadow: 0px 0px 16px 1px #1E22AA;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Novedades/Novedades.vue